import { render } from "./BaseInput.vue?vue&type=template&id=4f2a47f5&scoped=true"
import script from "./BaseInput.vue?vue&type=script&lang=ts"
export * from "./BaseInput.vue?vue&type=script&lang=ts"

import "./BaseInput.vue?vue&type=style&index=0&id=4f2a47f5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4f2a47f5"

export default script